import {
  onMounted,
  onActivated,
  onDeactivated,
  onBeforeUnmount,
  watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useRouterTab } from '../router/useRouterTab';
import { useIframeKeepAlive } from './useIframeKeepAlive';
import type { IframeSpec, IframePlacement } from './types';

export function useKeepAliveSlot(
  getKey: () => string,
  getSpec: () => IframeSpec,
  getMaxLive?: () => number | undefined,
  getPlacement?: () => IframePlacement,
) {
  const route = useRoute();
  const { getRefreshToken } = useRouterTab();
  const {
    claim,
    activate: markActive,
    deactivate: markInactive,
  } = useIframeKeepAlive();

  function reclaim() {
    claim(getKey(), getSpec(), {
      tabFullPath: route.fullPath,
      nonce: getRefreshToken(route.fullPath),
      maxLive: getMaxLive?.(),
      placement: getPlacement?.(),
    });
  }

  function activate() {
    reclaim();
    markActive(getKey());
  }

  function deactivate() {
    markInactive(getKey());
  }

  watch([getKey, getSpec], reclaim, { deep: true });

  onMounted(activate);
  onActivated(activate);
  onDeactivated(deactivate);
  onBeforeUnmount(deactivate);
}
